export default function _isTransformer(obj) {
  return obj != null && typeof obj['@@transducer/step'] === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_isTransformer.js
// module id = 220
// module chunks = 0